<template>
    <div class="grid p-fluid">
      <!-- {{vehicle_data}} -->
      <div class="col-12 md:col-4">
        <div class="card card-w-title" style="height: 800px">
          <div style="col-12 md;text-align:center">
            <img v-if="vehicle_data.photos"
              :src="vehicle_data.photos[0]"
              style="width: 200px;height:200px; border-radius: 20%"
            />
            <img v-else
              src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
              style="width: 200px; border-radius: 20%"
            />
            <hr />
          </div>
          <div style="">
            <div class="grid">
              <!-- <div class="row"> -->
                <div class="col-6 md:col-6"><b>Status</b> </div>
                <div class="col-6 md:col-6">
                    <span v-if="vehicle_data.status == 'Active' || vehicle_data.status == 'active'">
                        <badge :value="vehicle_data.status" severity="success"></badge>
                    </span>
                    <span v-if="vehicle_data.status == 'InActive' || vehicle_data.status == 'In Active'">
                        <badge :value="vehicle_data.status" severity="warning"></badge>
                    </span>
                    <span v-if="vehicle_data.status == 'InActive' || vehicle_data.status == 'In Active'">
                        <badge :value="vehicle_data.status" severity="warning"></badge>
                    </span>
                </div>
                <div class="col-6 md:col-6"><b>Registration No.</b> </div>
                <div class="col-6 md:col-6">{{vehicle_data.registration_number}}</div>
                <div class="col-6 md:col-6"><b>Vehicle Type</b></div>
                <div class="col-6 md:col-6">{{vehicle_data.vehicle_type}}</div>
                <div class="col-6 md:col-6"><b>RC Mobile No.</b></div>
                <div class="col-6 md:col-6">{{vehicle_data.mobile_number_rc}}</div>
                <div class="col-6 md:col-6"><b>Rc No.</b></div>
                <div class="col-6 md:col-6">{{vehicle_data.rc_number}}</div>
                <div class="col-6 md:col-6"><b>Make</b></div>
                <div class="col-6 md:col-6">{{vehicle_data.make}}</div>
                <div class="col-6 md:col-6"><b>Model</b></div>
                <div class="col-6 md:col-6" >{{vehicle_data.model}}</div>
                <div class="col-6 md:col-6"><b>Fuel Type</b></div>
                <div class="col-6 md:col-6" >{{vehicle_data.fuel_type}}</div>
                <div class="col-6 md:col-6"><b>Make Year</b></div>
                <div class="col-6 md:col-6" >{{vehicle_data.make_year}}</div>
                <div class="col-6 md:col-6"><b>Fitness Validity</b></div>
                <div class="col-6 md:col-6" >{{D_M_Y_formatDate(vehicle_data.fitness_validity)}}</div>
                <div class="col-6 md:col-6"><b>PUC Validity</b></div>
                <div class="col-6 md:col-6" >{{D_M_Y_formatDate(vehicle_data.puc_validity)}}</div>
                <div class="col-6 md:col-6"><b>Insurance Validity</b></div>
                <div class="col-6 md:col-6" >{{D_M_Y_formatDate(vehicle_data.insurance_validity)}}</div>
            </div>
          </div>
          <hr>
        </div>
      </div>
      <div class="col-12 md:col-8">
        <div class="card card-w-title" style="height: 800px">
      <!-- {{vehicle_data}} -->
            <tabs
      v-model="selectedTab"
    >
    <!-- {{tabs}} -->
      <tab
        class="tab"
        v-for="(tab, i) in tabs"
        :key="`t${i}`"
        :val="tab"
        :label="tab"
        :indicator="true"
      />
    </tabs>
      <tab-panels
      v-model="selectedTab"
      :animate="true"
    >
      <tab-panel >
        <!-- {{selected_tab}} -->
        <loading
              :active="isLoadingModel"
              :can-cancel="true"
              
              color="#173EA3"
              :is-full-page="fullPage"
            ></loading>
            <!-- {{groupUserList}} -->
           
        <VehicleMapRoute    :vehicle_id="vehicle_id" :client_ids="client_id" v-if="selectedTab=='Route' && vehicle_id && client_id"></VehicleMapRoute>
        <driver_map_to_vehicle  :owner_id="owner_id"  :vehicle_id="vehicle_id" :client_ids="client_id" v-if="selectedTab=='Driver' && vehicle_id && client_id"></driver_map_to_vehicle>

        
      </tab-panel>
    </tab-panels>
  
          
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Tabs, Tab, TabPanels, TabPanel } from 'vue3-tabs';
  import VehicleMapRoute from '../components/menu/Vehicle_Map_Route'
  import driver_map_to_vehicle from '../components/menu/driver_map_to_vehicle'


  

  import apis from "@/apis";
  
  
  export default {
    data() {
      return {
          active:"active",
          tabs : ['Route','Driver'],
          selectedTab: "Route",
          userType:"Rider",
          owner_id:'',
          vehicle_data:[],
          vehicle_id:'',
          client_id:'',
          vehicle_type:"",
          groupUserList:[], 
          groupVehicleList:[], 
          isLoadingModel:false
      };
    },
    async mounted(){
      
      if(localStorage.getItem('saveprofilevehicledata'))
      {
         this.vehicle_data=await JSON.parse(localStorage.getItem('saveprofilevehicledata'));
         this.vehicle_id= await this.vehicle_data._id;
         this.client_id= await this.vehicle_data.client_id;
         this.owner_id   = await this.vehicle_data.owner_id;

         this.vehicle_type= await this.vehicle_data.vehicle_type;
      
      }
      await localStorage.setItem('saveprofilevehicledata','');
      
      
    },
    async created(){
      
    },
    methods: {

      
    
      D_M_Y_formatDate(date_parm)
      {
        if(date_parm)
        {
          let date = new Date(date_parm);
          let dd = date.getDate();
          let mm = date.getMonth() + 1;
          let yyyy = date.getFullYear();
          let new_date = dd+"-"+mm + "-" + yyyy ;
          // alert(dd)
          if(dd.toString()!="NaN")
          {
            //this.receipt_new_date = new_date;
            return new_date;
          }
          else
          {
            return date_parm;
          }
        }
      },
      toggleMenu(event) {
        this.$refs.menu.toggle(event);
      },
      onContextRightClick(event) {
        this.$refs.contextMenu.show(event);
      },
    },
    components:{
          Tabs,
      Tab,
      TabPanels,
      TabPanel,
      VehicleMapRoute,
      driver_map_to_vehicle
      
      
    }
  };
  </script>